export const wait = ms => new Promise(r => setTimeout(r, ms));

export const throttle = (func, limit) => {
    let inThrottle;
    return (...args) => {
        if (!inThrottle) {
            func(...args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit)
        }
    }
};
